import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.APPS;

export default {
    getTabCount(params) {
        return Axios.post(
            `${baseURL}billing/invoice/get-tab-count`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response.resource;
            }
            return null;
        });
    },
    updateInvoice(params) {
        return Axios.post(`${baseURLci}billing/estimate/save`, params).then(
            response => response.data
        );
    },
    checkClient(params) {
        return Axios.get(`${baseURLci}ajax/client/client_check`, {
            params: params
        }).then(response => response.data);
    },
    prePostInvoice(params) {
        return Axios.post(`${baseURL}billing/invoice/prepost-reopen`, {
            invoice_id: params.invoice_id
        }).then(response => response.data);
    },
    prePostInvoiceCI(params) {
        return Axios.get(`${baseURLci}billing/reopen/prePostReopenInvoice`, {
            params: params
        }).then(response => response.data);
    },
    postInvoiceReopen(params) {
        return Axios.post(`${baseURL}billing/invoice/post-reopen`, params).then(
            response => response.data
        );
    },
    postInvoice(params) {
        return Axios.post(
            `${baseURLci}billing//reopen/postReopenInvoice`,
            params
        ).then(response => response.data);
    }
};
